import React, { useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

export default function CopyWidget(props) {
  const { copyText, isHTML } = props;
  const [isCopied, setIsCopied] = useState(false);
  const blob = new Blob([copyText], { type: "text/html" });
  const data = new ClipboardItem({ "text/html": blob });

  const handleCopy = async () => {
    setIsCopied(true);
    if (isHTML) {
      navigator.clipboard.write([data]);
    }
    setTimeout(() => setIsCopied(false), 1500); // Reset after 1.5 seconds
  };

  return (
    <div className="ml-1">
      <CopyToClipboard text={copyText} onCopy={handleCopy}>
        <button>
          {isCopied ? <i className="fa-solid fa-copy"></i> : <i className="fa-regular fa-copy"></i>}
        </button>
      </CopyToClipboard>
    </div>
  );
}